/**
 * Clinicarx - Plataforma de serviços de saúde para farmácias e consultórios
 *
 * --------------------------------------------------------------------------
 * Service Appoint
 * --------------------------------------------------------------------------
 *
 * TODO: Descrever
 *
 * @package     Marketplace
 * @subpackage  Home / Services / Appointment
 * @author      André Menezes   <andre.menezes@clinicarx.com.br>
 * @author      Brenda Lee      <brenda.lee@clinicar.com.br>
 * @author      Vanessa Augutis <vanessa.algutis@clinicar.com.br>
 * @category    Component, Services, Appointment
 * @tags        patient, validation, wizard form
 * @since       0.1.0
 * @version     1.0.0 - Init of project
 * @license     Proprietary
 * @copyright   Copyright (C) 2021 Clinicarx - All rights reserved
 */

import Component from "vue-class-component";
import ServiceAppointProps from "@c/Home/Services/ServiceAppoint/ServiceAppointProp";
import ServiceCalendarComponent from "@c/Home/Services/ServiceCalendar/ServiceCalendarComponent";
import ServiceConfirmationComponent from "@c/Home/Services/ServiceConfirmation/ServiceConfirmationComponent";
import ServiceDetailComponent from "@c/Home/Services/ServiceAppoint/ServiceDetail/ServiceDetailComponent";
import ServiceTimeComponent from "@c/Home/Services/ServiceTimeSelect/ServiceTimeSelectComponent";
import AppointConfirmationComponent from "@c/Home/Services/AppointConfirmation/AppointConfirmation.vue";

import InfoModal from "@/components/Util/InfoModal/InfoModal.vue";
import ValidatePatient from "@/components/Patient/ValidatePatient/ValidatePatient.vue";
import PatientForm from "@/components/Patient/PatientForm/PatientForm.vue";
import Patient from "@/api/Services/Patient";
import AppointmentService from "@/api/Services/Appointment";
import moment from "moment";

import { PatientInterface } from "@/api/Interfaces/PatientInterface";
import { SelectTimeInterface } from "@c/Home/Services/ServiceTimeSelect/SelectTimeInterface";
import { AppointmentInterface } from "@/api/Interfaces/AppointmentInterface";
import { isNull } from "lodash";
import { bus } from "@/main";
import { ResponseInterface } from "@/api/Interfaces/ResponseInterface";
import { mapGetters } from "vuex";
import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";

/**
 * --------------------------------------------------------------------------
 * Componente de agendamento de serviços
 * --------------------------------------------------------------------------
 *
 * TODO: Descrever
 *
 * @class       ServiceAppointComponent
 * @extends     Vue
 * @mixins      ServiceAppointProps
 *
 * @component   PatientForm                  - TODO: Descrever
 * @component   ServiceCalendarComponent     - TODO: Descrever
 * @component   ServiceConfirmationComponent - TODO: Descrever
 * @component   ServiceDetailComponent       - TODO: Descrever
 * @component   ServiceTimeComponent         - TODO: Descrever
 * @component   ValidatePatient              - TODO: Descrever
 *
 * @since       0.1.0
 * @version     1.0.0 - Init of project
 */
@Component<ServiceAppointComponent>({
  name: "ServiceAppoint",

  components: {
    "patient-form": PatientForm,
    "service-calendar": ServiceCalendarComponent,
    "service-confirmation": ServiceConfirmationComponent,
    "service-detail": ServiceDetailComponent,
    "service-time": ServiceTimeComponent,
    "validate-patient": ValidatePatient,
    "info-modal": InfoModal,
    "appoint-confirmation": AppointConfirmationComponent,
  },
  computed: {
    ...mapGetters([
      "getService",
      "getDate",
      "getTime",
      "getCpf",
      "getPatientData",
      "getFormPatientData",
      "getAppointmentDate",
      "getSearchDate"
    ]),
    buttonLabel() {
      if (this.cx_wizardActivePage === 2) {
        if (this.getPatientData?.document && !this.getPatientData?.email) {
          return "Atualizar";
        } else {
          return "Continuar";
        }
      } else if (this.cx_wizardActivePage === 4) {
        return "Confirmar agendamento";
      } else {
        return "Continuar";
      }
    }
  }
})
export default class ServiceAppointComponent extends ServiceAppointProps {
  getService!: ServiceInterface;
  getDate!: string;
  getTime!: SelectTimeInterface;
  getCpf!: string;
  getPatientData!: PatientInterface;
  getFormPatientData!: { [index: string]: string | number };
  getAppointmentDate!: string;
  getSearchDate!: string;
  cx_initialTime: boolean;

  showMessage = false;
  newTime = false;
  incompletePatientInfo = false;
  notRegisteredPatient = {};
  patientEmail = "";
  removeData = false;
  showRequestErrorModal = false;

  headerText: Array<{ title: string; subTitle: string }>;
  /**
   * Entidade de registro de agendamento de serviço
   *
   * @var     {AppointmentInterface} cx_appointment
   * @since   0.1.0
   */
  cx_appointment!: AppointmentInterface;

  /**
   * ID da clínica
   *
   * @var     {number | null} cx_clinicId
   * @since   0.1.0
   */
  cx_clinicId = null;

  /**
   * Data de agendamento
   *
   * @var     {string} cx_date
   * @since   0.1.0
   */
  cx_date = "";

  /**
   * Desabilitar o botão de próximo passo
   *
   * @var     {boolean} cx_disableNext
   * @since   0.1.0
   */
  cx_disableNext = true;

  /**
   * Verifica se o modal está fechado ou aberto
   *
   * @var     {boolean} cx_opened
   * @since   0.1.0
   */
  cx_opened = this.opened;

  /**
   * CPF do paciente
   *
   * @var     {string} cx_patientDocument
   * @since   0.1.0
   */
  cx_patientDocument = "";

  /**
   * Objeto de serviço
   *
   * @var     {ServiceInterface} cx_service
   * @since   0.1.0
   */
  cx_service = this.service;

  /**
   * Página do formulário wizard
   *
   * @var     {number} cx_wizardActivePage
   * @since   0.1.0
   */
  cx_wizardActivePage = -1;

  /**
   * Dados do formulário de cadastro do paciente
   *
   * @var     {object} cx_patientFormData
   * @since   0.1.0
   */
  cx_patientFormData: { [index: string]: string | number } = {};

  /**
   * Entidade de paciente
   *
   * @var     {PatientInterface} cx_patient
   * @since   0.1.0
   */
  cx_patient!: PatientInterface;

  /**
   * Horário do agendamento
   *
   * @var     {SelectTimeInterface} cx_time
   * @since   0.1.0
   */
  cx_time!: SelectTimeInterface;

  /**
   * Formulario do paciente e valido
   *
   * @var     {bool} cx_isValidPatient
   * @since   0.1.0
   */
  cx_isValidPatient = false;

  /**
   * Termos de aceite
   *
   * @var     {bool} cx_termsAccepted
   * @since   0.1.0
   */
  cx_termsAccepted = false;

  /**
   * Aparecer checkbox dos termos de uso
   *
   * @var     {bool} cx_show_terms
   * @since   0.1.0
   */
  cx_show_terms = true;

  /**
   * Aparecer checkbox de dicas no e-mail
   *
   * @var     {string} cx_date_email
   * @since   0.1.0
   */
  cx_date_email = null;

  /**
   * Aparecer checkbox de termos de uso
   *
   * @var     {string} cx_date_terms
   * @since   0.1.0
   */
  cx_date_terms = null;

  /**
   * Aceitar envio de dicas no e-mail
   *
   * @var     {bool} cx_mktOptAccepted
   * @since   0.1.0
   */
  cx_mktOptAccepted = false;

  /**
   * Aparecer checkbox de dicas no e-mail
   *
   * @var     {bool} cx_show_opt
   * @since   0.1.0
   */
  cx_show_opt = true;

  /**
   * Exibe erros do formulario do paciente
   *
   * @var     {bool} cx_showPatientErrors
   * @since   0.1.0
   */
  cx_showPatientErrors = false;
  cx_loading = false;
  cx_nextDateAvailable = "";

  /**
   * Referências dos componentes
   *
   * @param {HTMLFormElement} patientForm - TODO: Descrever
   * @param {HTMLFormElement} serviceForm - TODO: Descrever
   */
  $refs!: {
    patientForm: HTMLFormElement;
    validatePatientRef: HTMLFormElement;
    infoModal: any;
  };

  /**
   * --------------------------------------------------------------------------
   * Métodos de inicialização
   * --------------------------------------------------------------------------
   *
   * TODO: Descrever
   *
   * @method  constructor
   * @since   0.1.0
   * @version 1.0.0 - Init of project
   * @returns {void}
   */
  constructor() {
    super();
    this.cx_initialTime = false;

    this.cx_service = this.service;
    this.cx_patient = {} as PatientInterface;
    this.cx_appointment = {} as AppointmentInterface;
    this.cx_time = {} as SelectTimeInterface;
    this.cx_termsAccepted = false;
    this.headerText = [
      {
        title: "Escolha um horário",
        subTitle: "Selecione o melhor horário para o atendimento.",
      },
      {
        title: "Identifique o paciente",
        subTitle: "Informe o CPF da pessoa que será atendida.",
      },
      {
        title: "Faça o cadastro antecipado",
        subTitle: "Preencha com os dados do paciente, para agilizar o atendimento.",
      },
      {
        title: "Confirme os dados do agendamento",
        subTitle: "",
      },
      {
        title: "Agendamento realizado com sucesso!",
        subTitle: "",
      },
    ];
    this.cx_mktOptAccepted = false;
  }

  /**
   * --------------------------------------------------------------------------
   * Disparado ao montar o componente
   * --------------------------------------------------------------------------
   *
   * TODO: Descrever
   *
   * @method  mounted
   * @since   0.1.0
   * @version 1.0.0 - Init of project
   * @returns {void}
   */
  mounted(): void {
    if (!this.dayHasHoursAvailable) {
      this.$store.commit("setTime", "");
      this.getHoursAvailableInterval();
    }
    
    this.$store.commit("setSearchDate", this.getDate);
    this.cx_service = this.service;
    this.cx_show_terms = true;
    if (this.getService.clinic?.id !== this.getTime?.clinic_id) {
      this.cx_initialTime = false;
    } else {
      this.cx_initialTime = (this.getTime != null && Object.keys(this.getTime).length !== 0) ? true : false;
    }

    this.cx_wizardActivePage = this.cx_initialTime ? 2 : 1;
    this.disableNext();

    this.cx_show_opt = true;
  }

  getHoursAvailableInterval(): void {
    const currentDate = new Date(this.getDate);
    const formattedCurrentDate = currentDate.getFullYear() + "-" + (currentDate.getMonth()+1).toString().padStart(2, "0") + "-" + currentDate.getDate().toString().padStart(2, "0")
    const endDate = new Date(this.getDate);
    endDate.setDate(endDate.getDate() + 7);
    const formmattedEndDate = endDate.getFullYear() + "-" + (endDate.getMonth()+1).toString().padStart(2, "0") + "-" + endDate.getDate().toString().padStart(2, "0")

    AppointmentService.getHoursAvailableInterval(this.cx_service.clinic_id, formattedCurrentDate, formmattedEndDate)
    .then((response: any) => {
      const hasHourAvailableInNextSevenDays = response.data.data.find((clinicHours: { available: boolean; }) => clinicHours.available === true);
      if (hasHourAvailableInNextSevenDays) {
        this.cx_nextDateAvailable = hasHourAvailableInNextSevenDays.date;
        this.cx_loading = false;
      } 
    })
    .catch((error) => console.log(error))
  }

  /**
   * TODO: O NOME DO MÉTODO É INCOMPATÍVEL COM A EXECUÇÃO DO MESMO
   */
  getDateCalendar(date: string): void {
    this.cx_date = date;
    this.disableNext();
  }

  /**
   * --------------------------------------------------------------------------
   * Retorna o horário selecionado do agendamento
   * --------------------------------------------------------------------------
   *
   * TODO: Descrever
   *
   * @method  getTimeSelected
   * @param   {SelectTimeInterface} time - TODO: Descrever
   * @since   0.1.0
   * @version 1.0.0 - Init of project
   * @returns {void}
   */
  getTimeSelected(time: SelectTimeInterface): void {
    this.cx_time = time;
    this.disableNext();
  }

  /**
   * --------------------------------------------------------------------------
   * Tenta ir para próxima página
   * --------------------------------------------------------------------------
   *
   * TODO: Descrever
   *
   * @method  nextStep
   * @since   0.1.0
   * @version 1.0.0 - Init of project
   * @returns {void}
   * @type    async
   */
  async nextStep(): Promise<void> {
    if (this.cx_wizardActivePage < 4) {
      if(this.cx_nextDateAvailable) {
        const date = new Date(this.cx_nextDateAvailable.replace(/-/g, '/'));
        this.$store.commit("setSearchDate", date);
        this.cx_nextDateAvailable = "";
      }
      else if (this.cx_wizardActivePage === 1 && !this.getTime) {
        this.showMessage = true;
      }
      else if (this.cx_wizardActivePage === 1 && this.newTime) {
        this.cx_wizardActivePage = 4;
        this.newTime = false;
      }
      else if (this.cx_wizardActivePage === 2) {
        this.setLoading(true);
        if (this.getPatientData?.document && this.getPatientData?.email) {
          this.incompletePatientInfo = false;
          this.cx_wizardActivePage += 2;
        } else {
          if (!this.cx_patientDocument && !this.$refs.validatePatientRef.cx_patientDocument) {
            this.setLoading(false);
            this.$refs.validatePatientRef.errorMessage = "Campo de preenchimento obrigatório.";
          } else if (this.cx_patientDocument) {
            this.cx_wizardActivePage += 1;
            this.incompletePatientInfo = false;
            if (this.getPatientData?.document && !this.getPatientData?.email) {
              setTimeout(() => {
                this.$refs.patientForm.patientEmail = (!this.removeData) ? this.patientEmail : "";
              }, 0);
              this.headerText[2].title = "Atualize o cadastro";
              this.incompletePatientInfo = true;
            }
               
            
            
          } else {
            this.$refs.validatePatientRef.errorMessage = "CPF inválido. Informe um número válido para continuar.";
            this.setLoading(false);
          }
        }
      } else if (this.cx_wizardActivePage === 3) {
        this.setLoading(true);
        if(this.cx_patientFormData.email) await this.emailAlreadyExist(this.cx_service.clinic_id);
        if (!this.cx_isValidPatient) {
          this.setLoading(false);
          let invalidValue;
          const isEmpty = !Object.values(this.cx_patientFormData).every((value: any) => value);
          if (this.$refs.patientForm.preValidation) invalidValue = true;
          this.$refs.patientForm.invalidForm = invalidValue || isEmpty;
          this.$store.commit("setFormPatientData", this.cx_patientFormData);
        } else {
          this.cx_wizardActivePage += 1;
        } 
      } else this.cx_wizardActivePage += 1;
    } else if (this.cx_wizardActivePage === 4) {
      if (this.cx_isValidPatient) {
        this.cx_showPatientErrors = false;
        this.setLoading(true);
        const appoint = await this.setServiceAppoint();
        if (appoint) this.cx_wizardActivePage += 1;
      } else {
        this.cx_showPatientErrors = true;
      }
    }

    this.disableNext();
  }

  /**
   * TODO: Descrever
   */
  backStep(): void {
    this.showMessage = false;
    if (this.cx_wizardActivePage === 3) {
      this.patientEmail = String(this.cx_patientFormData?.email);
    }
    if (this.cx_wizardActivePage === 4) {
      this.removeData = false;
      if (this.cx_patientFormData) {
        this.notRegisteredPatient = this.cx_patientFormData;
      } else {
        this.cx_patientFormData = this.getFormPatientData;
      }
      this.cx_show_terms = true;
    
    }

    if (this.getPatientData?.document && this.getPatientData?.email && !this.incompletePatientInfo) {
      this.cx_wizardActivePage -= 2
    } else {
      this.cx_wizardActivePage -= 1
    }
    this.disableNext();
  }

  /**
   * ----------------------------------------------------------------------------
   * Desabilita o botão para o próximo passo
   * ----------------------------------------------------------------------------
   *
   * TODO: Descrever
   *
   * @version 1.0
   * @since   0.1.0
   * @type    async
   * @return  {Promise<void>}
   *
   * @uses    this.cx_wizardActivePage<number>
   * @uses    this.verifyState<Function>
   */
  async disableNext(): Promise<void> {
    this.cx_disableNext = true;
    this.cx_disableNext = await this.verifyState(this.cx_wizardActivePage);
  }

  /**
   * --------------------------------------------------------------------------
   * Verificação de estado do formulário wizard
   * --------------------------------------------------------------------------
   *
   * Valida cada etapa para saber se pode ou não ir para o
   * próximo passo.
   *
   * @version 1.0
   * @since   0.1.0
   * @param   Number page         - Página do formulário wizard
   * @returns Promise<boolean>    - É necessário esperar os componente internos
   *                                serem renderizados para dar resposta e isso
   *                                pode demorar alguns milisegundos. Por isso
   *                                é necessário usar a Promise para aguardar a
   *                                resposta.
   * @type    async
   *
   * @uses    $refs
   * @link    https://class-component.vuejs.org/guide/refs-type-extension.html
   *
   * @uses    Promise
   * @link    https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/Promise
   *
   * @uses    this.cx_appointment<AppointmentInterface>
   * @uses    this.cx_patientDocument<string>
   * @uses    this.$refs.patientForm.$refs.form<VueConstructor>
   */
  async verifyState(page: number): Promise<boolean> {
    if (page === 1) return !this.getTime || !this.getTime.time || this.getTime.time === "";
    else if (page === 2) return this.cx_patientDocument === "";

    return false;
  }

  setLoading(bool: boolean): void {
    bool ? this.cx_loading = bool : setTimeout(() => this.cx_loading = bool, 200);
  }

  forceHideLoading() : void {
    this.cx_loading = false;
  }

  requestError(request: boolean) : void {
    this.showRequestErrorModal = request;
  }
 
  /**
   * TODO: Descrever
   * @uses    this.$refs.patientForm.$refs.form<VueConstructor>
   */
  async setServiceAppoint(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        const data: { [index: string]: number | string | { [index: string]: string | number } } = {
          clinic_id: this.getService.clinic_id,
          service_id: this.getService.id,
          start_at: this.toApiDate(this.getSearchDate, this.getTime.time || "00:00"),
          end_at: this.toApiDate(this.getSearchDate, this.getTime.end || "00:00"),
        };
        // Necessário declarar o objeto vazio para o typescript
        // instanciar antes de colocar dados dentro.
        //
        // Ao instanciar qualquer coisa na inicialização quando
        // modificado, os valores iniciais somem, por isso é
        // necessária a declaração do cpf após a inicialização.
        data["patient"] = {};
        data["patient"]["document"] = this.cx_patientDocument;

        const patientData = this.getPatientData ? this.getPatientData : this.cx_patientFormData;

        for (const [key, value] of Object.entries(patientData)) {
          // Na api está instanciado como $data[ 'patient' ][ key ].
          // Para manter o mesmo padrão de instanciação, é necessário
          // retirar o prefixo 'patient_' da chave de cada item.
          const keyName = key.replace("patient_", "");

          // Abaixo está uma lista de itens que existem no objeto
          // de paciente na API.
          if (["name", "document", "birthday", "email", "sex", "phone"].includes(keyName))
            data["patient"][keyName] = value;

          data["patient"]["mkt_terms_accepted"] = this.cx_termsAccepted as any;

          if (this.cx_patient && this.cx_patient.crx_id) {
            data["patient"]["crx_id"] = this.cx_patient.crx_id as any;
          }

          if (this.cx_termsAccepted) {
            if (!this.cx_date_terms) {
              data["patient"]["mkt_terms_accepted_date"] = new Date() as any;
            } else {
              data["patient"]["mkt_terms_accepted_date"] = this.cx_date_terms as any;
            }
          }
        }
        AppointmentService.setAppointment(data)
          .then((response) => {
            const responseData = response.data as ResponseInterface;
            this.cx_appointment = responseData.data;
            resolve(true);
          })
          .catch((error) => {
            this.cx_showPatientErrors = true;
            const responseError = error.response?.data.message.data;
            
            if (responseError?.patient) {
              const errors: any = {};

              for (const [key, value] of Object.entries(responseError.patient)) {
                const anyValue: any = value as any;
                if (key == "email") {
                  const message = anyValue.email
                    ? anyValue.email == "E-mail is undeliverable." ||
                      anyValue.email == "The provided value is invalid"
                      ? "Email já possui cadastro em nosso sistema. Informe outro para continuar."
                      : anyValue[key]
                    : anyValue._isUnique
                    ? "E-mail já utilizado"
                    : "Ocorreu um erro";

                  errors[`patient_${key}`] = message;
                } else {
                  errors[`patient_${key}`] = anyValue[key];
                }
              }
              this.$refs.patientForm.$refs.form.setCustomErrors(errors);
            } else if (responseError && !!responseError[0] && responseError[0] == "Unavailable schedule") {
              this.cx_wizardActivePage = 6;
            } else {
              this.cx_wizardActivePage = 7;
            }
            reject(error);
          })
          .finally( () => this.forceHideLoading());
      } catch (e) {
        this.forceHideLoading();
        reject(false);
      }
    });
  }

  /**
   * TODO: Descrever
   */
  closeAppoint(): void {
    this.cx_opened = false;
    this.cx_wizardActivePage = 1;
    this.$store.commit("setTime", null);
    this.$emit("close", this.cx_opened);
  }

  backStepError(): void {
    this.cx_wizardActivePage = 1;
    this.newTime = true;
  }

  /**
   * TODO: Descrever
   */
  patientFormHasUpdated(form: { [index: string]: string | number }): void {
    this.cx_patientFormData = form;
  }

  /**
   * TODO: Descrever
   */
  patientFormIsValid(isValid: boolean): void {
    // Como o botão valida se está inválido
    // e o formulário devolve se o mesmo está
    // válido, a verificação é inversa
    this.cx_isValidPatient = isValid;
    this.cx_disableNext = !isValid || !this.cx_termsAccepted;
  }

  /**
   * TODO: O NOME DO MÉTODO É INCOMPATÍVEL COM A SUA APLICAÇÃO
   */
  async isDocumentValid(isDocumentValid: boolean, document: string): Promise<void> {
    this.cx_patientDocument = isDocumentValid ? document : "";
    this.cx_isValidPatient = isDocumentValid ? true : false;
    this.cx_patientFormData["document"] = document;

    this.$store.commit("setCpf", isDocumentValid ? document : "");

    this.disableNext();
    if (isDocumentValid) await this.getPatient(this.getService.clinic_id, document);
  }

  /**
   * TODO: Descrever
   * @uses    this.$refs.patientForm.$refs.form<VueConstructor>
   */
  patientData(patientData: PatientInterface): void {
    this.cx_showPatientErrors = false;
    if (!isNull(patientData)) {
      const { name, email, sex, birthday, phone1, phone2, is_foreigner, phones } = patientData;

      if (patientData.mkt_terms_accepted) {
        this.cx_show_terms = false;
        this.cx_termsAccepted = true;
      } else {
        this.cx_show_terms = true;
      }

      if (patientData.mkt_email_accepted) {
        this.cx_show_opt = false;
        this.cx_mktOptAccepted = true;
      } else {
        this.cx_show_opt = true;
      }

      this.cx_patient = Object.assign({}, this.cx_patient, {
        ...this.cx_patient,
        name,
        email,
        birthday,
        phone1,
        phone2,
        is_foreigner,
        phones,
        sex,
      });
      this.cx_appointment.patient = this.cx_patient;

      this.cx_showPatientErrors = true;
    }
  }

  /**
   * TODO: ESSE MÉTODO PARECE REDUNDANTE
   *       VER './src/components/Patient/ValidatePatient/ValidatePatient.ts'
   */
  async getPatient(clinicId: string | number, patientDocument?: string): Promise<void> {
    this.setLoading(true);
    await Patient.getPatient(clinicId, patientDocument || this.cx_patientDocument)
      .then((response: any) => {
        this.cx_patient = response.data.data;
        this.$store.commit(
          "setPatient",
          response.data.data ? { ...response.data.data, document: patientDocument } : null
        );

        if (this.cx_patient?.mkt_terms_accepted) {
          this.cx_date_terms = response.data.data.mkt_terms_accepted_date;
          if (this.cx_patient?.mkt_email_accepted) {
            this.cx_date_email = response.data.data.mkt_email_accepted_date;
          }
        }
        this.patientData(this.cx_patient);
      })
      .catch((error) => {
        this.cx_showPatientErrors = false;
        this.cx_show_terms = true;
        this.showRequestErrorModal = true;
      })
      .finally(() => this.setLoading(false));
  }

  async emailAlreadyExist(clinicId: string | number, email?: string): Promise<void> {
    this.setLoading(true);
    await Patient.getPatientEmail(clinicId, email || String(this.cx_patientFormData?.email))
      .then((response: any) => {
        if(response.data?.data?.email) {
          this.$refs.patientForm.validationEmailMessage = "Este e-mail já está em uso. Insira um novo endereço de e-mail.";
          this.cx_showPatientErrors = true;
          this.cx_isValidPatient = false;
        }
      })
      .catch((error) => { 
        this.showRequestErrorModal = true;
      })
      .finally(() => this.setLoading(false));
  }

  toApiDate(date: string, time: string): string {
    return `${moment(date).format('YYYY-MM-DD')} ${time}`;
  }

  getPeriod(): number {
    if (this.getTime && this.getTime.time && this.getTime.end) {
      const start = this.getTime.time.split(":").map((item: string) => parseInt(item));
      const end = this.getTime.end.split(":").map((item: string) => parseInt(item));

      return (end[0] - start[0]) * 60 * 60 * 1000 + (end[1] - start[1]) * 60 * 1000;
    }
    return 0;
  }

  termsHasUpdated(value: boolean): void {
    this.cx_termsAccepted = value;
    this.disableNext();
  }

  formatDate(date: string) : string {
    const months = [
      'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
      'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
    ];
    const newDate = new Date(date);
    return `${newDate.getUTCDate().toString().padStart(2, "0")} de ${months[newDate.getMonth()]}` 
  }

  removeOldPatientData() {
    this.notRegisteredPatient = {};
    this.removeData = true;
  }
}
